import axios from "axios";

import { Roles, VaultDocumentModes } from "Features/Vault/VaultInterfaces";

export interface ISettings {
  application: {
    activityPanelEnabled: boolean;
    clientDefinedDataFieldsEnabled: boolean;
    displayAltPackage: boolean;
    exportLimit: number;
    vaultDocumentsPreSelected: VaultDocumentModes;
  };
  mers: {
    dataPointRegistrationsEnabled: boolean;
    delegateeForTransferEnabled: boolean;
    independentDeliveryEnabled: boolean;
    addDocumentEnabled: boolean;
    minReconciliationEnabled: boolean;
    securedPartyEnabled: boolean;
    securedPartyDelegateeEnabled: boolean;
    subservicerEnabled: boolean;
    transferWithoutDeliveryEnabled: boolean;
  };
}

export interface IAdminProfileViewModel {
  displayName: string;
  roles: Roles[];
  settings: ISettings;
}

export interface ISessionTimeoutResponse {
  remainingMilliseconds: number;
}

/**
 * Gets the profile for the currently logged in user
 * @returns A promise for the request
 */
export async function getUserProfile(): Promise<IAdminProfileViewModel> {
  const response = await axios.get("/api/profile");
  return response.data;
}

export async function logUserOut(): Promise<void> {
  await axios.post("/api/logout");
}

let timeoutLogout: Promise<void> | undefined;

export function sessionTimedOut(): Promise<void> {
  if (!timeoutLogout) {
    timeoutLogout = axios.post("/api/logout", undefined, { timeout: 5000 })
      .then(() => undefined, () => undefined)
      .finally(() => {
        window.location.href = "/app/signed-out";
        timeoutLogout = undefined;
      });
  }
  return timeoutLogout;
}

export async function keepAlive(): Promise<void> {
  await axios.post("/api/keepalive", undefined, { timeout: 5000 });
}

export async function getSessionTimeout(): Promise<number> {
  const response = await axios.get<ISessionTimeoutResponse>("/api/session-timeout", { timeout: 5000 });
  const remainingMilliseconds: unknown = response.data?.remainingMilliseconds;
  if (typeof remainingMilliseconds !== "number" || !Number.isFinite(remainingMilliseconds) || remainingMilliseconds < 0) {
    throw new Error("The session timeout response was invalid.");
  }

  return remainingMilliseconds;
}
